"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _responsiveBreakpoints = _interopRequireDefault(require("pricing-pages-unified-ui/utils/responsiveBreakpoints"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PhoneSupportWrapper = _styledComponents.default.div.withConfig({
  displayName: "PhoneSupportWrapper",
  componentId: "aacgl0-0"
})(["width:450px;margin:50px auto;", ""], _responsiveBreakpoints.default.phone(_templateObject()));

var _default = PhoneSupportWrapper;
exports.default = _default;
module.exports = exports.default;